// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1T8Yu","item":"PaymentsMobile_item__39ChA","label":"PaymentsMobile_label__2vY1H","amount":"PaymentsMobile_amount__1wGV4"};